import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { ResponsiveDialog } from '@cibo/ui'
import { useBulkConfirmControlGroups } from '..'
import { useNavigate, generatePath } from 'react-router'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { ACCOUNT_ROUTES } from 'navigation/types/routes'

export type BulkConfirmDialogProps = {
  open: boolean
  agreementId?: string
  groupCount?: number
  onClose(): void
}

export const BulkConfirmDialog = ({
  open,
  agreementId,
  onClose,
  groupCount,
}: BulkConfirmDialogProps) => {
  const { t } = useTranslation('impact/ControlGroups/BulkConfirmDialog')

  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const bulkConfirm = useBulkConfirmControlGroups()

  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      <DialogTitle>{t('Are you sure?')}</DialogTitle>

      <DialogContent>
        <Typography>{t('warning', { count: groupCount })}</Typography>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {t('keepEditing')}
        </Button>

        <LoadingButton
          variant="contained"
          onClick={() => {
            if (!agreementId) return

            bulkConfirm.mutateAsync(
              { agreementId },
              {
                onSuccess: () => {
                  enqueueSnackbar(t('confirmSuccess', { agreementName: 'Error Report' }), {
                    variant: 'info',
                  })

                  // @TODO go somewhere i can see my updated enrollment status 😩
                  navigate(generatePath(ACCOUNT_ROUTES.AGREEMENT_DETAIL, { agreementId }))
                },
              }
            )
          }}
          loading={bulkConfirm.isLoading}
        >
          {t('confirmPlots', { count: groupCount })}
        </LoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  )
}
